import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import Home from "../views/Home.vue";
import API from "../views/API";
// import Login from "../views/Login";
// import Register_mobile from "../views/Register_mobile"
import ServiceAgreement_mobile from "../views/mobile/ServiceAgreement_mobile"
import PrivacyPolicy_mobile from "../views/mobile/PrivacyPolicy_mobile"
// import Register from "../views/Register";
//手机端
import MobilePublicity from "../views/MobilePublicity"
import ServiceAgreement from "../views/ServicesAgreement";
import PrivacyPolicy from "../views/PrivacyPolicy";
// import ForgetPassword from "../views/Login_forgetPassword";

//关于培训班详情页
import courseDetail from "../views/courseDetail";

//报名页面
import signIn from "../views/signIn";
import signInContent from "../views/signInContent";
import signInResult from "../views/signInResult";
import offlineSignInResult from "../views/offlineSignInResult";
import offlineResult from "../views/offlineResult";

//线上课堂
import globalCourse from "../views/globalCourse";
import courseShow from "../views/courseShow";
import homeWork from "../views/homeWork";
import coursePlay from "../views/coursePlay";
import graduationCertificate from "../views/graduationCertificate";
import excellentRecognition from "../views/excellentRecognition";
//讲师专区
import teachingManage from "../views/userCenter/teachingManage"


//吉林一号大学
import universityUserCenter from "../views/university_userCenter"


//直播间
import directSeeding from "../views/directSeeding";
//线下报名
import offlineSignIn from "../views/offlineSignIn";



Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  base:"/learn",
  mode: "history",
  routes: [
      //讲师专区
    {
      path: "/teachingManage",
      name: "teachingManage",
      component: teachingManage,
    },
    //吉林一号大学，个人中心
    {
      path: "/universityUserCenter",
      name: "universityUserCenter",
      component: universityUserCenter,
    },
    // 新首页
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    // 关于培训班
    {
      path: "/courseDetail",
      name: "courseDetail",
      component: courseDetail,
    },
    // 报名
    {
      path: "/signIn",
      name: "signIn",
      component: signIn,
    },
    
    // 报名
    {
      path: "/signInContent",
      name: "signInContent",
      component: signInContent,
    },
    // 报名
    {
      path: "/signInResult",
      name: "signInResult",
      component: signInResult,
    },
    {
      path: "/offlineSignInResult",
      name: "offlineSignInResult",
      component: offlineSignInResult,
    },
    {
      path: "/offlineResult",
      name: "offlineResult",
      component: offlineResult,
    },
    // 线上课堂
    {
      path: "/globalCourse",
      name: "globalCourse",
      component: globalCourse,
    },
    {
      path: "/courseShow",
      name: "courseShow",
      component: courseShow,
    },
    //作业
    {
      path: "/homeWork",
      name: "homeWork",
      component: homeWork,
    },
    {
      path: "/coursePlay",
      name: "coursePlay",
      component: coursePlay,
    },
    {
      path: "/directSeeding",
      name: "directSeeding",
      component: directSeeding,
    },
    {
      path: "/offlineSignIn",
      name: "offlineSignIn",
      component: offlineSignIn,
    },
    
    {
      path: "/graduationCertificate",
      name: "graduationCertificate",
      component: graduationCertificate,
    },
    {
      path: "/excellentRecognition",
      name: "excellentRecognition",
      component: excellentRecognition,
    },
    
    
    {
      path: "/API",
      name: "API",
      component: API,
    },
    // {
    //   path: "/Login",
    //   name: "Login",
    //   component: Login,
    // },
    // {
    //   path: "/Register",
    //   name: "Register",
    //   component: Register,
    // },
    // {
    //   path: "/Register_mobile",
    //   name: "Register_mobile",
    //   component: Register_mobile,
    // },
    {
      path: "/MobilePublicity",
      name: "MobilePublicity",
      component: MobilePublicity,
    },
    {
      path: "/ServiceAgreement_mobile",
      name: "ServiceAgreement_mobile",
      component: ServiceAgreement_mobile,
    },
    {
      path:"/PrivacyPolicy_mobile",
      name:"PrivacyPolicy_mobile",
      component:PrivacyPolicy_mobile,
    },
    //服务条款
    {
      path: "/ServiceAgreement",
      name: "ServiceAgreement",
      component: ServiceAgreement,
    },
    //隐私协议
    {
      path: "/PrivacyPolicy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
    },
    //忘记密码
    // {
    //   path: "/ForgetPassword",
    //   name: "ForgetPassword",
    //   component: ForgetPassword,
    // },
    //其他输入都进入404中
    {
      path: "/404",
      component: () => import("@/views/exception/404"),
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});
// function smartAndRelaxJump(to, next) {
//   if (['/Archive/SmartModel', '/Archive/SmartModel/'].includes(to.path)) {
//     let selectedModel = localStorage.getItem('selectedModel');
//     if (selectedModel != 'r')
//       next('/Archive')
//   }
//   if (['/Archive', '/Archive/'].includes(to.path)) {
//     let selectedModel = localStorage.getItem('selectedModel');
//     if (selectedModel != 's')
//       next('/Archive/SmartModel')
//   }
// }
router.beforeEach((to, from, next) => {
  let token=getKey()
  if(token){
    token="Bearer "+token;
  }
  let param = new FormData()  // 创建form对象
  param.append('currentUrl', '/learn'+to.path)  // 通过append向form对象添加数据
  param.append('fromUrl', '/learn'+from.path)
  param.append('eventType', '0')
  // param.append('clientTime', null)
  axios.post('/loginapi/log/addOperationLog', param,
      {headers: {
          Authorization: token,
        }}).then(res => {
    // console.log('pv统计测试返回')
    // console.log(res)
  })
  next();
});

router.afterEach(() => {
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function () {
      document.getElementById("baidu_tj") &&
        document.getElementById("baidu_tj").remove();
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?dd1580c04617bb7a7575d022eda32336";
      hm.id = "baidu_tj";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    var _paq = _paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);
    (function () {
      var u = "//analytics.escience.org.cn/";
      _paq.push(["setTrackerUrl", u + "piwik.php"]);
      _paq.push(["setSiteId", "34"]);
      var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.type = "text/javascript";
      g.async = true;
      g.defer = true;
      g.src = u + "piwik.js";
      s.parentNode.insertBefore(g, s);
    })();
  }, 0);
});

function getCookie(cname) {
  return localStorage.getItem(cname);
}
function getKey() {
  return localStorage.getItem("token");
}
export default router;
